// @ts-check

import { Map } from 'immutable';
import { actionTypes as itemCommentsDialogActionsTypes } from '../../../actions/Dialogs/itemCommentsDialogActions';

/**
 * @typedef {import('../../../actions/Dialogs/itemCommentsDialogActions').ShowCommentsParams} ShowCommentsParams
 * 
 * @typedef {import('mat/js/components/Dialogs/ItemCommentsDialog/ItemCommentDialogTypes').ItemCommentsDialogState} ItemCommentsDialogState
 * @typedef {import('mat/js/components/Dialogs/ItemCommentsDialog/ItemCommentDialogTypes').ItemCommentsDialogStateMap} ItemCommentsDialogStateMap
 * 
 */


/** @type {ItemCommentsDialogState} */
let defaultState = {

  show: false,
  loading: false,

  itemId: null,
  itemDisplayName: null,
  itemType: null,

  comments: [],

  lastCommentSavedOn: null, // This is used to signal that the last comment was saved and the input should be cleared

};


/**
 * @param {ItemCommentsDialogStateMap} state
 * @param {{ type: string, payload?: any }} action
 * 
 * @returns {ItemCommentsDialogStateMap}
 * 
 */
export default function (state, action) {

  if (!state) {
    // @ts-ignore
    state = Map(defaultState);
  }


  switch (action.type) {

    case itemCommentsDialogActionsTypes.ITEM_COMMENTS_DIALOG__HIDE:
      // @ts-ignore
      return Map(defaultState);


    case itemCommentsDialogActionsTypes.ITEM_COMMENTS_DIALOG__SHOW:

      state = state.set('show', true);

      return state;


    case itemCommentsDialogActionsTypes.ITEM_COMMENTS_DIALOG__BUSY:

      state = state.set('loading', true);

      return state;


    case itemCommentsDialogActionsTypes.ITEM_COMMENTS_DIALOG__READY:

      state = state.set('loading', false);

      return state;


    case itemCommentsDialogActionsTypes.ITEM_COMMENTS_DIALOG__SET_ITEM_INFO:

      state = state.set('itemId', action.payload.itemId);
      state = state.set('itemType', action.payload.itemType);
      
      if (action.payload.itemDisplayName) {
        if (action.payload.itemDisplayName !== '--UNCHANGED--') {
          state = state.set('itemDisplayName', action.payload.itemDisplayName);
        }
      }

      return state;


    case itemCommentsDialogActionsTypes.ITEM_COMMENTS_DIALOG__SET_DATA:

      state = state.set('comments', action.payload);

      return state;


    case itemCommentsDialogActionsTypes.ITEM_COMMENTS_DIALOG__SET_LAST_COMMENT_SAVED_ON:

      // This is used to signal that the last comment was saved and the input should be cleared
      state = state.set('lastCommentSavedOn', new Date().getTime());

      return state;


    default:
      return state;

  }
}





